/** Responses spreadsheet (profiles, paste codes, CUSTOM grants). */
export const RESPONSES_SHEET_ID = '1njnU57hDxU9iEWn_W24z4reciaKkpdWqPIYahBbwbs8';
export const RESPONSES_SHEET_GID = '1281334660';

/** Public TSV export consumed by the profiles loader in the browser. */
export const RESPONSES_TSV_URL = `https://docs.google.com/spreadsheets/d/${RESPONSES_SHEET_ID}/export?format=tsv&id=${RESPONSES_SHEET_ID}&gid=${RESPONSES_SHEET_GID}`;

/** Google Form for submitting a new paste code / profile update. */
export const NEW_PASTE_URL = 'https://forms.gle/7ii2ft5T4iRpVRpA9';

/** Google Form for new badge idea submissions. */
export const BADGE_SUBMISSION_URL = 'https://forms.gle/Dd9m5FEWtSZhn2fY7';
